import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CTASection({ title, subtitle, primaryText = "Book a Growth Consultation", primaryTo = "/contact#book" }) {
  return (
    <section data-testid="cta-section" className="bg-white">
      <div className="sozos-container section-pad">
        <div className="relative overflow-hidden bg-[#0A1F44] rounded-md p-10 md:p-16">
          <div className="absolute inset-0 grid-pattern opacity-[0.08] pointer-events-none" />
          <div className="relative max-w-3xl">
            <p className="eyebrow text-blue-300">{subtitle || "Let’s build your revenue engine"}</p>
            <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-4 tracking-tight leading-[1.08]">
              {title || "Ready to grow pipeline you can forecast?"}
            </h3>
            <p className="text-slate-300 mt-5 text-base md:text-lg max-w-2xl">
              In a 30-minute call, we&apos;ll map your ICP, find white-space accounts, and outline a 90-day plan
              to lift qualified pipeline and revenue.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link to={primaryTo} data-testid="cta-primary" className="btn-primary">
                {primaryText} <ArrowUpRight className="w-4 h-4" />
              </Link>
              <Link to="/services" data-testid="cta-secondary" className="btn-ghost-white">
                Explore Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
